export const normalizeProtocolDate = (value) => {
  const text = String(value || '').trim()
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/)
  const czech = text.match(/^(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})$/)
  if (!iso && !czech) return ''
  const year = Number(iso ? iso[1] : czech[3])
  const month = Number(iso ? iso[2] : czech[2])
  const day = Number(iso ? iso[3] : czech[1])
  const date = new Date(Date.UTC(year, month - 1, day))
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return ''
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

export const getProtocolJobDate = (item) => {
  if (Object.prototype.hasOwnProperty.call(item, 'localDate')) return normalizeProtocolDate(item.localDate)
  const jobDate = normalizeProtocolDate(item.JobDate || item.jobDate)
  if (jobDate) return jobDate
  const mode = item.ScanMode || item.scanMode
  if (mode === 'same-day') {
    return normalizeProtocolDate(item.CapturedLocalDate || item.capturedLocalDate)
  }
  return normalizeProtocolDate(item.DetectedProtocolDate || item.detectedProtocolDate)
}

export const createScanDateMetadata = (scanMode, capturedAt = new Date()) => {
  if (scanMode !== 'same-day' && scanMode !== 'historical') throw new Error('Unknown scan mode')
  const capturedLocalDate = `${capturedAt.getFullYear()}-${String(capturedAt.getMonth() + 1).padStart(2, '0')}-${String(capturedAt.getDate()).padStart(2, '0')}`
  return {
    scanMode,
    capturedAt: capturedAt.toISOString(),
    capturedLocalDate,
    jobDate: scanMode === 'same-day' ? capturedLocalDate : null,
  }
}